<script>
    import { onMount } from "svelte";
    import Spinner from "./components/spinner.svelte";
    import { baseUrl, getUrlVars, inIframe, handleMargins, handleDarkModeSettings, useDarkMode, isForcedColorMode } from "../../scripts/loadExternalData";
    import { initTracking } from "../../scripts/tracker";


  // &dnApp=true&dnAppVersion=6.6.6&darkMode=1
  // core version + navigation, pagination modules:
  import Swiper, { FreeMode, Parallax, Scrollbar } from 'swiper';

  import "../../node_modules/swiper/swiper-bundle.min.css";



    
    export const events = initTracking();
  
    export const state = {
        headline: "",
        ingress: "",
        source: "",
        imageLayers:[],
        imageLayersReverse:[],
        aspectRatio:"",
        scrollSpeed:2,
        scrollGlide:'Lite',
        //Lite,Normalt,Mycket,Inget
        swiperjson:undefined,
        widgetLoaded:false,
        darkModeSettings:'Följ användarens tema',

    };
  
    export let graphicTitle = '';
    export let hasSentInView = false;

    $: myRenderDarkMode = getUrlVars().darkMode === '1';
    $: myRenderForcedColorMode = false;

    let aspectRatioPr = "";
    let aspectRatioDec = 1;
    let imageList = {};
    let longestImage = 1;
    let imageHeight = 1;
    let parabgwidth = 1;
    let slideCorrection = 1;
    let scrollGlideTal = 0.25;
    let scrollMomentun = true;

    let slideprogress = 0;


    onMount(() => {
      window.addEventListener("resize", () => postRatio());
  
      if(!inIframe()) {

        document.getElementsByTagName('body')[0].style.overflow = 'auto';
        document.getElementsByTagName('body')[0].style.margin = '0';

      } else {
        if(window.innerWidth <= 620) {
          document.getElementsByTagName('body')[0].style.margin = '0';
        }
      }
  






      burstRatio();
      setupLiveData();
      setupInviewEvent();
      fetchGraphicData();
    });


    function postRatio() {
      const containerElement = document.getElementsByTagName("body")[0];
  
      window.parent.postMessage(
        {
          ratio: containerElement.offsetHeight / window.innerWidth,
          location: window.location.href,
        },
        "*"
      );
}
  
function setupInviewEvent() {
      window.addEventListener("message", (ev) => {
        if(hasSentInView) return;
        
        if (typeof ev.data === "string" && ev.data.includes("INSIDE_VIEW")) {
          events.enterIntoView('Visible', 'Klick SVG', state.title || graphicTitle || '');
          hasSentInView = true;

          if(state.doStartAnimation){showTargets();}
          
        } else if(ev.data.isScrolledIntoView) {
          events.enterIntoView('Visible', 'Klick SVG', state.title || graphicTitle || '');
          hasSentInView = true;
        }
      });
}
  
function setupLiveData() {
      window.addEventListener("message", (ev) => {
        if (!ev.data.key || ev.data.value === undefined) return;
  
        const { key, value } = ev.data;
  
        if(key === 'legend') {
            state[key] = value.map(image => {
              return {
                url: image
              }
          })
        }

        state[key] = value;
        setTimeout(() => burstRatio(), 50);
        
      });
}
  
function fetchGraphicData() {
      fetch(`${baseUrl}/fields/${getUrlVars().id}`)
        .then((data) => data.json())
        .then(({ fields, title }) => {
          graphicTitle = title;
          
          for (let name in state) {
            if(!fields.find(({ key }) => key === name)) continue;
  
            state[name] = fields.find(({ key }) => key === name).value;
          }
  

          handleDarkModeSettings(false,false,state.darkModeSettings);
      
          myRenderDarkMode = useDarkMode();
          myRenderForcedColorMode = isForcedColorMode();

          if ( myRenderDarkMode ) {
            document.getElementsByTagName("body")[0].classList.add("body__dark-mode");
          } else {
            document.getElementsByTagName("body")[0].classList.add("body__light-mode");
          } 


          state.imageLayersReverse = state.imageLayers.reverse();

          if( state.aspectRatio == '1:1' ) {

            aspectRatioPr = 'padding-top:100%';
            aspectRatioDec = 1;

          } else if (state.aspectRatio == '5:6' ) {

            aspectRatioPr = 'padding-top:120%'; 
            aspectRatioDec = 6/5;

          } else if (state.aspectRatio == '5:7' ) {

            aspectRatioPr = 'padding-top:140%';
            aspectRatioDec = 7/5;

          } else if (state.aspectRatio == '2:3' ) {

            aspectRatioPr = 'padding-top:150%';
            aspectRatioDec = 3/2;

          } else if (state.aspectRatio == '8:13' ) {

            aspectRatioPr = 'padding-top:162.5%';
            aspectRatioDec = 13/8;

          } else if (state.aspectRatio == '9:16' ) {

            aspectRatioPr = 'padding-top:177.777%';
            aspectRatioDec = 16/9;

          } else if (state.aspectRatio == '1:2' ) {

            aspectRatioPr = 'padding-top:200%';
            aspectRatioDec = 2;

          } 
          //state.scrollSpeed = 1;
           //Lite,Normalt,Mycket,Inget

          if(state.scrollGlide == 'Lite'){
            scrollGlideTal = 0.25;
          } else if(state.scrollGlide == 'Normalt') {
            scrollGlideTal = 0.5;
          } else if(state.scrollGlide == 'Mycket') {
            scrollGlideTal = 1;
          } else if(state.scrollGlide == 'Inget') {
            scrollMomentun = false;
          }
       


          setTimeout(function () { 
            burstRatio();
          }, 20);
          
        });
}

function burstRatio() {
    postRatio();

      setTimeout(function () {
        postRatio();
      }, 50);
      setTimeout(function () {
        postRatio();
      }, 100);
      setTimeout(function () {
        postRatio();
      }, 300);
      setTimeout(function () {
        postRatio();
      }, 500);
      setTimeout(function () {
        postRatio();
      }, 1000);

      setTimeout(function () {
        postRatio();
      }, 1500);

}


function startSwiper(){
 
  var swiper = "";

  if( typeof(swiperjson) == "undefined" || swiperjson == null || swiperjson == "undefined" ) {

    swiper = new Swiper(".mySwiper", {
          modules: [FreeMode, Parallax, Scrollbar ],
            "freeMode":{
              "enabled":true,
              "momentum":scrollMomentun,
              "momentumRatio":scrollGlideTal,
              "momentumVelocityRatio":scrollGlideTal,
              "minimumVelocity":0.02,
              "momentumBounce":true
            },

            "parallax": true,
            "slidesPerView": "auto",
            "spaceBetween":0,
            "touchRatio":state.scrollSpeed,
            "touchAngle":45,
            
            "scrollbar": {
              "el": ".swiper-scrollbar",
              "hide":false,
              "draggable":true,
              "dragSize":30,
              "dragClass":"swiper-scrollbar-drag",
              "snapOnRelease":false
            }
      });

  } else {

        state.swiperjson = JSON.parse(state.swiperjson2);
        state.swiperjson['modules'] = [];
        state.swiperjson['modules'][0] = FreeMode;
        state.swiperjson['modules'][1] = Parallax;
        state.swiperjson['modules'][2] = Scrollbar;

        swiper = new Swiper(".mySwiper", state.swiperjson);
  }



swiper.on('progress', function (swiper,progress) {
  
  slideprogress = progress+correctProgress(progress);

});


state.widgetLoaded = 'true';

}


function correctProgress(progress){
  
  let ret = 0;

  let t = 3;

  let abst = Math.abs(1-progress);

  if(progress < 0.0001 ){

    ret = 0;

  }  else  {
 
    t = 3 * (progress*10) ;
    if(t > 3){ t = 3};

    if(progress > 0.90){ t = 3 * (abst*10) ;};
    ret = (t - (progress*(t*2)))/100;
  }

  if(progress > 0.99){
    return 0;
  } else {
    return ret;
  }
  
}


export const createLoadObserver = handler => {
	let waiting = 0

	const onload = el => {
		waiting++
		el.addEventListener('load', () => {
      //imageList.push(el);
      imageList[el.alt] = {};
      imageList[el.alt]['l'] = el.clientWidth;

      if(typeof (el.getAttribute("data-up-popper")) != "undefined" && el.getAttribute("data-up-popper") != null ) {

        if(typeof (el.getAttribute("data-up-popper").split(":")[1]) != "undefined" && el.getAttribute("data-up-popper").split(":")[1] != null ) {

          let tmp = el.getAttribute("data-up-popper").split(":")[1];
          imageList[el.alt]['showpercent'] = tmp/100;

        } else {

          imageList[el.alt]['showpercent'] = 0;

        }
        
      }
      if( el.src.includes("webp")  || el.src.includes("gif")   ){

        imageList[el.alt]['animation'] = true;
      }

      if (el.clientWidth > longestImage){longestImage = el.clientWidth; imageHeight = el.clientHeight; }

			waiting--
			if (waiting === 0) {
				handler()
			}
		})
	}

	return onload
}

const onload = createLoadObserver(() => {
       
        let temp = document.getElementsByClassName("swiper")[0].clientWidth;
        slideCorrection = ((temp/longestImage * 100));

        for (var key in imageList) {
          if (imageList.hasOwnProperty(key)) {
              imageList[key]['procent'] = ( ((imageList[key].l/longestImage)*100) - slideCorrection).toFixed(2);
          }
        }

        parabgwidth = ((longestImage/imageHeight) * 100) * aspectRatioDec;

        setTimeout(function () {
          startSwiper();
        }, 500);
        
});



</script>



<style global type="text/scss" lang="scss">

main {
      position: relative;
      height: 100%;
    }

main {
      background: #fff;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14px;
      color: #000;
      margin: 0;
      padding: 0;
    }

  


    .phone {
    position: relative;
    width:100%;
    padding-left: 0px;
    padding-right: 0px;
    box-sizing: border-box;
    background-color: #fff;
    z-index: 1;
    }
    .app {
    position: relative;
    width:100%;
    height: 0px;
    padding-top:140%;
    box-sizing: border-box;
    }
    .appwrapper{
    position: absolute;
    left: 0;
    top:0;
    width: 100%;
    height: 100%;
    }

    .swiper {
      width: 100%;
      height: 100%;
      
    }

    .swiper-slide {
      font-size: 18px;
      color: #000;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0px;
      margin:0px;
      opacity:0;
      background-color: greenyellow;
      
    }

    .parallax-bgOrginal {
      position: absolute;
      left: 0;
      top: 0;
      width: 130%;
      height: 100%;
      -webkit-background-size: cover;
      background-size: cover;
      background-position: center;
    }

    .parallax-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 0%;
      height: 100%;

    }

    .parallax-image {
      height: 100%;
    }


    .swiper-slide .title {
      font-size: 41px;
      font-weight: 300;
    }

    .swiper-slide .subtitle {
      font-size: 21px;
    }

    .swiper-slide .text {
      font-size: 14px;
      max-width: 400px;
      line-height: 1.3;
    }


.swiper-scrollbar.swiper-scrollbar-horizontalx {
  bottom: 15px;
  position: absolute;
  width: 95%;
  height: 5px;
  z-index: 100;
  margin-left: 1.2%;
  background: #9a9a9a;
  border: 0px solid #a3a3a3;

}

.swiper-scrollbar.swiper-scrollbar-horizontalx {

  background: #9a9a9a;
  border: 0px solid #a3a3a3;

}

.swiper-scrollbar-drag { 
  width:30px;
  height:30px;
  background: #fff;
  border: 1px solid #616161;
  border-radius: 50%;
  top:-15px;
  overflow: hidden;
  }

  .main__dark-mode  .swiper-scrollbar-drag { 
    border: 1px solid #fff;
  }



.navigate_left {
  position: absolute;
  left: 4px;
  top: 8px;
  z-index: 100;
  width: 14px;
  height: 14px;
  fill: #333;

}

.navigate_right {
  position: absolute;
  left: 13px;
  top: 8px;
  z-index: 100;
  width: 14px;
  height: 14px;
  fill: #333;

}



  .swiper-scrollbar-wrap {

    position: relative;
    width:100%;
    height: 25px;
    z-index: 100;

  }

  .swiper-scrollbar {
    background-color: #e5e5e5;
  }

  .main__dark-mode .swiper-scrollbar {
    background-color: #5d5c5c;
  }


  .debug {
    display:none;
  }



.swiper-wrapper {
    z-index: 1;
   }

.parallax-bg { 

  z-index: 100;
  pointer-events: none;

}

.parallax-cover {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0%;
  overflow: hidden;
  
}

.parallax-uppopper .parallax-image {

  transition: opacity 0.5s ease-in-out;
  -webkit-transition: opacity 0.5s ease-in-out;

}

.parallax-uppopper {
  opacity:0;
}
.parallax-uppopper.show {
  opacity:1;
}

.parallax-image.show {
  opacity:1;
} 
.parallax-image.hide {
  opacity:0;
} 

.parallax-image-shadow {
  position: absolute;
  left:0;
  bottom:0;
}


:global( .x ) {
backface-visibility: hidden;
transform-style: preserve-3d;
transform: translate3d(0, 0, 0);
perspective: 1000px;
transform:translateZ(0);

-webkit-backface-visibility: hidden;
-webkit-transform-style: preserve-3d;
-webkit-transform: translate3d(0, 0, 0);
-webkit-perspective: 1000px;
-webkit-transform:translateZ(0);

transform: translateZ(1px); 
-webkit-transform:translateZ(1px);

} 





</style>

<main  
class={`main__content-wrapper ${handleMargins() ? "main__padded-width" : "main__normal-width"} ${myRenderDarkMode ? "main__dark-mode" : "main__light-mode"} ${myRenderForcedColorMode ? "main__padded-top-bottom" : ""} ${handleMargins() ? 'main__full-width' : ''}`}>

  <Spinner widgetLoaded={state.widgetLoaded} appDarkMode ={myRenderDarkMode} />
  {#if state.headline}
    <div class="standard-title">
      {state.headline}
    </div>
  {/if}
  {#if state.ingress}
    <div class="standard-ingress">
      {@html state.ingress}
    </div>
  {/if}

<div class="phone">
    <div class="app" style={`${state.aspectRatio != '' ? aspectRatioPr : '' }`}>
    <div class="appwrapper">
  
  
    <div style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff" class="swiper mySwiper">

        {#each state.imageLayersReverse as bg_image, index}
          {#if bg_image[1].substring(0, 2).toUpperCase() == 'VI'}
            {#if bg_image[2].substring(0, 2).toUpperCase() == 'FI'}
            <div class="parallax-bg" style={`width:${parabgwidth}%;`}  data-swiper-parallax={`-0%`} > 
              <img use:onload src={`${bg_image[0]}`}  alt="parallax-image-{index}" class="parallax-image" > 
            </div>

            {:else if  bg_image[2].substring(0, 2).toUpperCase() == 'VÄ'}
            <div class="parallax-bg parallax-progress" style={`width:${parabgwidth}%;`} data-swiper-parallax={`-${ imageList.hasOwnProperty('parallax-image-'+index) ? imageList['parallax-image-'+index].hasOwnProperty('procent') ? imageList['parallax-image-'+index].procent :'0' : '0'}%`} >  
              <div class="parallax-cover" style={`width:${slideprogress*100}%;`}>
              <img use:onload src={`${bg_image[0]}`}  alt="parallax-image-{index}" class="parallax-image" > 
            </div>
            </div>
            {:else if  bg_image[2].substring(0, 2).toUpperCase() == 'PO'}
            <div  class={`parallax-bg parallax-uppopper ${(imageList.hasOwnProperty('parallax-image-'+index) ? imageList['parallax-image-'+index].hasOwnProperty('showpercent') ? imageList['parallax-image-'+index].showpercent :0 :0) < slideprogress ? 'show': 'hide'}`}  style={`width:${parabgwidth}%;`} data-swiper-parallax={`-${ imageList.hasOwnProperty('parallax-image-'+index) ? imageList['parallax-image-'+index].hasOwnProperty('procent') ? imageList['parallax-image-'+index].procent :'0' : '0'}%`} > 
              <!-- skuggbild för att hantera laddning osv -->
              <img use:onload src={`${bg_image[0]}`}  data-up-popper={`${bg_image[2]}`} alt="parallax-image-{index}"  class={`parallax-image parallax-image-shadow hide`}> 
              {#if state.widgetLoaded && (imageList.hasOwnProperty('parallax-image-'+index) && imageList['parallax-image-'+index].hasOwnProperty('showpercent') && imageList['parallax-image-'+index].hasOwnProperty('animation') && imageList['parallax-image-'+index].showpercent < slideprogress)}
               <!-- om animation visa denna bild -->  
              <img src={`${bg_image[0]}`} alt='img' class={`parallax-image  show}`}> 
              {:else}
              <!-- vanlig bild fejdas in -->  
              <img  src={`${bg_image[0]}`}   alt="img"  class={`parallax-image ${(imageList.hasOwnProperty('parallax-image-'+index) ? imageList['parallax-image-'+index].hasOwnProperty('showpercent') ? imageList['parallax-image-'+index].showpercent :0 :0) < slideprogress ? 'show': 'hide'}`}>     
              {/if}
            </div>
            {:else}
            <div class="parallax-bg" style={`width:${parabgwidth}%;`} data-swiper-parallax={`-${ imageList.hasOwnProperty('parallax-image-'+index) ? imageList['parallax-image-'+index].hasOwnProperty('procent') ? imageList['parallax-image-'+index].procent :'0' : '0'}%`} > 
              <img use:onload src={`${bg_image[0]}`}  alt="parallax-image-{index}" class="parallax-image" > 
            </div>
            {/if}
          {/if}  
        {/each}
  
      <div class="swiper-wrapper">

        {#each Array(1) as _, index (index)}

        <div class="swiper-slide" style={`width:${parabgwidth}%;`}>
          <div class="text" ></div>
        </div>
    
        {/each}
  
  
      </div>


    </div>

  
    
  
  </div>
  </div>
  </div>
  <div class="swiper-scrollbar-wrap">
  <div class='swiper-scrollbar'>
    <div class='swiper-scrollbar-drag'>

      <svg class='navigate_left'><use xlink:href='#navigate_left' /></svg>
      <svg class='navigate_right'><use xlink:href='#navigate_right' /></svg>

    </div>
  </div>
  </div>

  {#if state.source}
  <div class="standard-source">
    {@html state.source}<span class="debug">debug 1.44</span>
  </div>
{/if}


</main>